import "../../css/app.css";

import { useState, useEffect } from "react";
import Header from "../components/Header";
import Nav from "../components/Nav";
import MyWork from "../components/MyWork";
import ContactMe from "../components/Contact Me";
import Footer from "../components/Footer";
import About from "../components/About";
import FloatingSocialMediaIcons from "../components/FloatingSocialMediaIcons";
import "../scripts/animations";


export default function App() {
    const switchToLightDistance = 100;
    const displayMainSocialMediaLinks = 900;

    const [switchToLight, setSwitchToLight] = useState(false);
    const [showCvNavButton, setShowCvNavButton] = useState(false);

    useEffect(() => {
        document.onscroll = () => {
            if (window.scrollY > switchToLightDistance && !switchToLight)
                setSwitchToLight(true);
            else if (window.scrollY < switchToLightDistance && switchToLight)
                setSwitchToLight(false);

            let headerCvButtonRect = document.getElementById("header-cv-button").getBoundingClientRect();

            if (headerCvButtonRect.y < 75 && !showCvNavButton)
                setShowCvNavButton(true);
            else if (headerCvButtonRect.y > 75 && showCvNavButton)
                setShowCvNavButton(false);

            let mainSocialMediaLinks = document.getElementById("main-sm-links");
            let hideClass = "main__sm-links--hide";

            if (window.scrollY >= displayMainSocialMediaLinks && mainSocialMediaLinks.classList.contains(hideClass))
                mainSocialMediaLinks.classList.toggle(hideClass);
            else if (window.scrollY < displayMainSocialMediaLinks && !mainSocialMediaLinks.classList.contains(hideClass))
                mainSocialMediaLinks.classList.toggle(hideClass);
        }
    });

    useEffect(() => {
        const css = (color) => `
                html { 
                    scrollbar-color: #6EF183 #${color} !important;
                }
                
                ::-webkit-scrollbar {
                    background: #${color} !important;
                }
                
                ::-webkit-scrollbar-thumb {
                    border-color: #${color} !important;
                }
            `;

        document.getElementById("scroll-bar-style").innerHTML = switchToLight ? css("FFF") : css("191725");
    }, [switchToLight]);

    return (
        <>
            <Nav switchToLight={switchToLight} showCvNavButton={showCvNavButton} />
            <Header switchToLight={switchToLight} />

            <main className="main">
                <FloatingSocialMediaIcons className="main__sm-links main__sm-links--hide" id="main-sm-links" />
                <About />
                <MyWork />
                <ContactMe />
            </main>

            <Footer />
        </>
    );
}
